// components/ConfirmationDialog.jsx
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';
import React from 'react';

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirmação',
    message = 'Tem certeza que deseja realizar esta ação?',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    confirmColor = 'error',
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogContent>
                <Typography variant="h6" sx={{ textAlign: 'center', mb: 2 }}>
                    {title}
                </Typography>
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
                <Button
                    type="button"
                    onClick={onClose}
                    variant="outlined"
                    sx={{ minWidth: 100 }}
                >
                    {cancelText}
                </Button>
                <Button
                    type="button"
                    onClick={onConfirm}
                    variant="contained"
                    color={confirmColor}
                    sx={{ minWidth: 100 }}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
